import { render, staticRenderFns } from "./AnalyzeChannelSettings.vue?vue&type=template&id=90a6a2c2&scoped=true&"
import script from "./AnalyzeChannelSettings.vue?vue&type=script&lang=js&"
export * from "./AnalyzeChannelSettings.vue?vue&type=script&lang=js&"
import style0 from "./AnalyzeChannelSettings.vue?vue&type=style&index=0&id=90a6a2c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a6a2c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90a6a2c2')) {
      api.createRecord('90a6a2c2', component.options)
    } else {
      api.reload('90a6a2c2', component.options)
    }
    module.hot.accept("./AnalyzeChannelSettings.vue?vue&type=template&id=90a6a2c2&scoped=true&", function () {
      api.rerender('90a6a2c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/AnalyzeChannelSettings.vue"
export default component.exports